<template lang="pug">
  div
    .relative
      textarea.border.border-grey-border.rounded-4.p-4.px-10(
        maxLength="1000"
        @input.lazy="$emit('input', $event.target.value)"  
        @blur.lazy="$emit('onblur', { val:$event.target.value, key:name})"
        :value="value" 
        :disabled="isDisabled" 
        :required="required" 
        :placeholder="placeholder" 
        class="focus:outline-none " 
        :class="{'border-error': error, 'px-6': prefix || suffix, 'cursor-not-allowed': isDisabled, 'border-grey-borderDisable': isDisabled }" 
        :maxLength="maxLength" 
        :style="{'width': width, 'height': height, 'resize': 'none' , 'border' : `solid 1px ${allColor}`}")
      
      .absolute(class="top-1/2 left-3 transform rounded -translate-y-1/2")
        slot(:name="prefix"  v-if="prefix")
      .absolute(class="top-1/2 right-3 transform rounded -translate-y-1/2")
        slot(:name="suffix"  v-if="suffix")
    .error.flex.items-center.justify-between.relative.text-grey-80
      small.text-error.pt-3.absolute(v-show="error") {{error}}
      .textLength.text-right.w-full(:class="{'text-error': textMax >= maxLength }" ) {{textMax}} / {{maxLength}}
</template>

<script>
export default {
  name: "Textarea",
  props: {
    name:String,
    value: [String, Number],
    required: Boolean,
    prefix: String,
    placeholder: String,
    suffix: String,
    maxLength: {
      type: [String, Number],
    },
    width: {
      type: String,
      default: '150px'
    },
    height: {
      type: String,
      default: '120px'
    },
    allColor:{
      type: String,
    },
    error: String,
    isDisabled: Boolean,
  },
  computed:{
    textMax: function(){
      // let remText = this.value.replace(/ /g, "");
      if(this.value.length >= this.maxLength){
        return this.maxLength
      }else{
        return this.value.length
      }
      
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
